import { httpsCallable } from "firebase/functions"
import { functions } from "./firebase"

const messagePassengers = async (eventId, vehicleIndex, message) => {
  const messagePassengersFunction = httpsCallable(functions, "messagePassengers")
  const response = await messagePassengersFunction({ eventId, vehicleIndex, message })
  return response.data
}

const submitContactForm = async (name, email, message) => {
  const submitContactFormFunction = httpsCallable(functions, "submitContactForm")
  const response = await submitContactFormFunction({ name, email, message })
  return response.data
}

export {
  messagePassengers,
  submitContactForm
}
